<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
<v-card>
<v-list>
    <v-list-item>
        <v-list-item-content>
            <v-list-item-subtitle>Přihlášený uživatel</v-list-item-subtitle>
            <v-list-item-title>{{ userFullName }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-list-item>
        <v-list-item-content>
            <v-list-item-subtitle>Zařízení</v-list-item-subtitle>
            <v-list-item-title>{{ auth.device.name }} ({{ auth.device.code }})</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-list-item  v-if="userBase">
        <v-list-item-content>
            <v-list-item-subtitle>Jednotka</v-list-item-subtitle>
            <v-list-item-title>{{ userBase.name }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-divider class="mt-2"></v-divider>
    <v-list-item @click="logout">
        <v-list-item-avatar>
            <v-icon>eject</v-icon>
        </v-list-item-avatar>
        <v-list-item-content >
            <v-list-item-title>Odhlásit se</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item @click="openChangePassword">
        <v-list-item-avatar>
            <v-icon>lock</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title>Změna hesla</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-dialog v-model="changePasswordModal" max-width="400">
        <change-user-password v-if="changePasswordModal" @onClose="closeChangePasswordModal"></change-user-password>
    </v-dialog>
</v-list>
</v-card>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import moment from "moment/moment";
import ChangeUserPassword from "@/components/auth/UserPassword.vue";

export default {
    name: 'header-user-card',
    components: {ChangeUserPassword},
    data() {
        return {
            changePasswordModal: false,
        }
    },
    computed: {
        ...mapGetters('auth', {
            userFullName: 'fullName',
        }),
        ...mapGetters('bases', {
            userBase: 'getUserBase',
        }),
        ...mapState({
            auth: state => state.auth,
            pubNubStatus: state => state.pubNubStatus,
        }),
    },
    methods: {
        openChangePassword() {
            this.changePasswordModal = true;
            this.$emit('close-menu');
        },
        restart() {
            window.location.href = "/?" + moment();
        },
        closeChangePasswordModal() {
            this.changePasswordModal = false;
        },
        ...mapActions('auth', {
            logout: 'logout',
        }),
    },
}
</script>
